import { render } from "./ServiceTable.vue?vue&type=template&id=90c41c56&scoped=true"
import script from "./ServiceTable.vue?vue&type=script&lang=js"
export * from "./ServiceTable.vue?vue&type=script&lang=js"

import "./ServiceTable.vue?vue&type=style&index=0&id=90c41c56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c41c56"]])

export default __exports__